import posthog from 'posthog-js';

const posthogKey = typeof __POSTHOG_PROJECT_KEY__ !== 'undefined' ? __POSTHOG_PROJECT_KEY__ : '';
const posthogHost = typeof __POSTHOG_API_HOST__ !== 'undefined' ? __POSTHOG_API_HOST__ : 'https://eu.i.posthog.com';

export const isPostHogConfigured = Boolean(posthogKey);

/** True while a logged-in user is being tracked. Logged-out pages (login etc.) never send anything. */
let active = false;

export function isPostHogActive(): boolean {
  return active;
}

/**
 * Starts PostHog for a logged-in user. Init is deferred until here so the login page
 * loads no PostHog script, sets no cookie and records nothing.
 */
export function startPostHogForUser(): void {
  if (!isPostHogConfigured || active) return;
  try {
    if (!posthog.__loaded) {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        capture_pageview: false,
        capture_pageleave: true,
        person_profiles: 'identified_only',
        persistence: 'localStorage+cookie',
        disable_session_recording: false,
        session_recording: {
          maskAllInputs: true,
        },
      });
    }
    // Opt-out from a previous logout is persisted; lift it for the new session.
    if (posthog.has_opted_out_capturing()) {
      posthog.opt_in_capturing();
    }
    posthog.startSessionRecording();
    active = true;
  } catch {
    /* PostHog unavailable — tracking is best effort */
  }
}

/** Clears PostHog identity and stops all capturing after logout (shared browser safety). */
export function resetPostHogAfterLogout(): void {
  if (!active) return;
  active = false;
  try {
    posthog.reset();
    posthog.stopSessionRecording();
    posthog.opt_out_capturing();
  } catch {
    /* PostHog not configured or not yet loaded */
  }
}
